/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} File_Export_Image_Subtitles_DescInputs */

const en_file_export_image_subtitles_desc = /** @type {(inputs: File_Export_Image_Subtitles_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`PNG images with BDN XML`)
};

const fr_file_export_image_subtitles_desc = /** @type {(inputs: File_Export_Image_Subtitles_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Images PNG avec XML BDN`)
};

const de_file_export_image_subtitles_desc = /** @type {(inputs: File_Export_Image_Subtitles_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`PNG-Bilder mit BDN-XML`)
};

const it_file_export_image_subtitles_desc = /** @type {(inputs: File_Export_Image_Subtitles_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Immagini PNG con BDN XML`)
};

const ru_file_export_image_subtitles_desc = /** @type {(inputs: File_Export_Image_Subtitles_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`PNG-изображения с BDN XML`)
};

const es_file_export_image_subtitles_desc = /** @type {(inputs: File_Export_Image_Subtitles_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Imágenes PNG con BDN XML`)
};

const zh_cn2_file_export_image_subtitles_desc = /** @type {(inputs: File_Export_Image_Subtitles_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`带有 BDN XML 的 PNG 图像`)
};

const ja_file_export_image_subtitles_desc = /** @type {(inputs: File_Export_Image_Subtitles_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`BDN XML を使用した PNG 画像`)
};

const hi_file_export_image_subtitles_desc = /** @type {(inputs: File_Export_Image_Subtitles_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`बीडीएन एक्सएमएल के साथ पीएनजी छवियां`)
};

const pt_pt2_file_export_image_subtitles_desc = /** @type {(inputs: File_Export_Image_Subtitles_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Imagens PNG com XML BDN`)
};

/**
* | output |
* | --- |
* | "PNG images with BDN XML" |
*
* @param {File_Export_Image_Subtitles_DescInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const file_export_image_subtitles_desc = /** @type {((inputs?: File_Export_Image_Subtitles_DescInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<File_Export_Image_Subtitles_DescInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_file_export_image_subtitles_desc(inputs)
	if (locale === "de") return de_file_export_image_subtitles_desc(inputs)
	if (locale === "it") return it_file_export_image_subtitles_desc(inputs)
	if (locale === "ru") return ru_file_export_image_subtitles_desc(inputs)
	if (locale === "es") return es_file_export_image_subtitles_desc(inputs)
	if (locale === "zh-CN") return zh_cn2_file_export_image_subtitles_desc(inputs)
	if (locale === "ja") return ja_file_export_image_subtitles_desc(inputs)
	if (locale === "hi") return hi_file_export_image_subtitles_desc(inputs)
	if (locale === "pt-PT") return pt_pt2_file_export_image_subtitles_desc(inputs)
	return en_file_export_image_subtitles_desc(inputs)
});